import RecipeTemplate from './RecipeTemplate';
export default RecipeTemplate;
